import React from 'react';
import { useNavigate } from "react-router-dom";
import { Button } from '@/components/ui/button';

function LogOutModal({ setModal }) {
  const navigator = useNavigate();

  const logOutHandler = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigator("/login");
  };

  return (
    <div className="h-screen w-screen backdrop-blur-2xl flex items-center justify-center absolute z-[1000]">
      <div className="w-fit h-fit border-[2px] border-black space-y-3 rounded-lg p-8">
        <h1>Do you want to log out?</h1>
        <div className="flex justify-evenly">
          <Button variant={"destructive"} onClick={logOutHandler} >Yes</Button>
          <Button onClick={() => setModal(false)} >No</Button>
        </div>
      </div>
    </div>
  );
}

export default LogOutModal;
